import { createFileRoute } from '@tanstack/react-router';
import SendVolumeTab from '@/pages/workspaces/broadcasts/send-volume/index.page';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import { SendVolumeTabGuard } from '@/pages/workspaces/broadcasts/routing';
import { validateSendVolumeSearch } from '@/pages/workspaces/broadcasts/url-state';

function SendVolumeRoute() {
  return (
    <SendVolumeTabGuard>
      <RumPageRendered>
        <SendVolumeTab />
      </RumPageRendered>
    </SendVolumeTabGuard>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/broadcasts/send-volume')({
  component: SendVolumeRoute,
  validateSearch: validateSendVolumeSearch,
});
